import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=70933fa7"
import script from "./TitleBox.vue?vue&type=script&lang=js"
export * from "./TitleBox.vue?vue&type=script&lang=js"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=70933fa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports